/**
 * hide
 * @param {Object} obj - dom element to hide
 */
__.hide = function(obj) {
  if (obj && obj.style.display !== 'none') {
    obj.style.display = 'none';
  }
};
